/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Ad_DescriptionInputs */

const en_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate an AI-powered audio description script for the current video.`)
};

const fr_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer un script de description audio basé sur l'IA pour la vidéo actuelle.`)
};

const de_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren Sie ein KI-gestütztes Audiobeschreibungsskript für das aktuelle Video.`)
};

const it_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera una descrizione audio basata sull'intelligenza artificiale per il video corrente.`)
};

const ru_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгенерируйте скрипт аудиоописания для текущего видео с помощью искусственного интеллекта.`)
};

const es_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera un guion de audiodescripción con inteligencia artificial para el vídeo actual.`)
};

const zh_cn2_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为当前视频生成人工智能音频描述脚本。`)
};

const ja_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の動画に対して、AIを活用した音声解説スクリプトを生成します。`)
};

const hi_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान वीडियो के लिए एआई-संचालित ऑडियो विवरण स्क्रिप्ट तैयार करें।`)
};

const pt_pt2_automatic_ad_description = /** @type {(inputs: Automatic_Ad_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere um roteiro de descrição de áudio com inteligência artificial para o vídeo atual.`)
};

/**
* | output |
* | --- |
* | "Generate an AI-powered audio description script for the current video." |
*
* @param {Automatic_Ad_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_ad_description = /** @type {((inputs?: Automatic_Ad_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Ad_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_ad_description(inputs)
	if (locale === "de") return de_automatic_ad_description(inputs)
	if (locale === "it") return it_automatic_ad_description(inputs)
	if (locale === "ru") return ru_automatic_ad_description(inputs)
	if (locale === "es") return es_automatic_ad_description(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_ad_description(inputs)
	if (locale === "ja") return ja_automatic_ad_description(inputs)
	if (locale === "hi") return hi_automatic_ad_description(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_ad_description(inputs)
	return en_automatic_ad_description(inputs)
});